import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, SAMPLE_TO_SALE_SCREEN, HOME_TODAY_SCREEN, COMMON, API_CONSTANTS } from '../../global/Constants';
import './sample-to-sale.css';
import Header from '../common/Header';
import Select from 'react-select';
import DesktopFooter from '../common/DesktopFooter';
import AddLocalImages from '../common/AddLocalImages';
import GpsCoordinates from '../common/GpsCoordinates';
import Utilities from '../../global/Utilities';
import SyncLoader from '../common/loader/SyncLoader';

class HarvestDetailsPage extends Component {

    constructor(props) {
        super(props)

        this.state = {
            activity: {},
            type: 'text',
            harvestingDate: '',
            yieldValue: '',
            moisture: '',
            population: '',
            hybrid: 'SS223',
            varietyHarvestingDate: '',
            varietyYield: '',
            varietyMoisture: '',
            varietyPopulation: '',
            remarks: '',
            latitude: '',
            longitude: "",
            nextActivity: '',
            nextPickDate: '',
            images: [],

            checkVariety: [],
            selectedCheckVariety: null,

            nextActivityOptions: [
                { id: 0, name: COMMON.YES, checked: true },
                { id: 1, name: COMMON.NO, checked: false },
            ],
        }
    }

    componentDidMount() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            if (this.props.location.state !== undefined) {
                let activity = this.props.location.state.activity;
                if (activity !== undefined && activity !== null) {
                    let data = activity?.stage;
                    const check_variety = data?.params?.check_varity?.map(({ competitor_hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }));

                    this.setState({
                        activity: activity,
                        data: data,
                        harvestingDate: data?.params?.harvest_date,
                        varietyHarvestingDate: data?.params?.check_variety_harvest_date,
                        checkVariety: check_variety,
                        selectedCheckVariety: check_variety?.[0],
                        nextActivity: data?.params?.is_next_harvest,
                        nextPickDate: data?.params?.next_harvest_date,
                    });

                    if (activity?.harvest != null) {
                        let harvest = activity?.harvest;

                        this.setState({
                            harvestingDate: harvest.harvest_date,
                            yieldValue: harvest.harvest_yield,
                            moisture: harvest.harvest_moisture,
                            population: harvest.harvest_population,
                            selectedCheckVariety: harvest.competitor_hybrid,
                            varietyHarvestingDate: harvest.check_variety_harvest_date,
                            varietyYield: harvest.check_variety_harvest_yield,
                            varietyMoisture: harvest.check_variety_harvest_moisture,
                            varietyPopulation: harvest.check_variety_harvest_population,
                            remarks: harvest.remark,
                            images: harvest.images
                        });
                    }
                }

            } else {
                this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE)
        }
    }

    _backButton = () => {
        //this.props.history.push(ALL_ROUTES.SAMPLE_TO_SALE_ROUTE);
        this.props.history.push({
            pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
            state: { activity: this.state.activity }
        });
    }


    getInitialState = () => {
        return {
            type: 'text'
        };
    }

    onFocus = () => {
        this.setState({
            type: 'date'
        });
    }

    onBlur = () => {
        this.setState({
            type: 'text'
        });
    }

    changeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleChanged = (e) => {
        this.setState({ nextActivity: e.target.value });
    }

    handleAddImages = (images, selectedFiles) => {
        this.setState({ images: selectedFiles });
    }

    handleVarietyHybrid = item => {
        this.setState({ selectedCheckVariety: item });
    };

    getCoordinates = (latLng) => {
        this.setState({
            latitude: latLng.latitude,
            longitude: latLng.longitude
        })
    }

    _handleSaveClick = () => {
        const { harvestingDate, yieldValue, moisture, population, selectedCheckVariety, varietyHarvestingDate, varietyYield, varietyMoisture,
            varietyPopulation, images, nextActivity, nextPickDate, remarks, latitude, longitude } = this.state;

        let harvestObj = {
            harvest_date: harvestingDate,
            harvest_yield: yieldValue,
            harvest_yield_weight_id: 1,
            harvest_moisture: moisture,
            harvest_population: population,
            check_variety_harvest_date: varietyHarvestingDate,
            check_variety_harvest_yield: varietyYield,
            check_variety_harvest_yield_weight_id: 1,
            check_variety_harvest_moisture: varietyMoisture,
            check_variety_harvest_population: varietyPopulation,
            competitor_hybrid: selectedCheckVariety,

            // No Any UI
            harvest_row_distance: 0,
            harvest_row_distance_id: 0,
            check_variety_row_distance: 0,
            check_variety_row_distance_id: 0,

            remark: remarks,
            images: images,
            latitude: latitude,
            longitude: longitude,
            nextActivity: nextActivity,
            nextPickDate: nextPickDate
        }

        this.setState(prevState => ({
            activity: { ...prevState.activity, harvest: harvestObj }
        }), () => {
            this.props.history.push({
                pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
                state: { activity: this.state.activity }
            });
        });

    }

    isFormValid() {
        const { harvestingDate, yieldValue, moisture, varietyHarvestingDate, varietyYield, varietyMoisture,
            varietyPopulation, images } = this.state;
        return !harvestingDate || !yieldValue || !moisture || !varietyHarvestingDate || !varietyYield || !varietyMoisture
            || !varietyPopulation || images === 0;
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { activity, harvestingDate, yieldValue, moisture, population, varietyHarvestingDate, varietyYield, varietyMoisture,
            varietyPopulation, remarks, nextPickDate, checkVariety, selectedCheckVariety, nextActivity, nextActivityOptions,
            images } = this.state;
        const { isSyncLoading, tableName } = this.state;
        const NextActivityOptions = nextActivityOptions.map((item, i) => {
            if (nextActivity === item.checked) {
                return (
                    <div className="radiobox-container" key={i}>
                        <input type="radio" name="radio1" value={item.checked} checked onChange={this.handleChanged} />
                        <span className="checkmark">{item.name}</span>
                    </div>
                )
            } else {
                return (
                    <div className="radiobox-container" key={i}>
                        <input type="radio" name="radio1" value={item.checked} onChange={this.handleChanged} />
                        <span className="checkmark">{item.name}</span>
                    </div>
                )
            }
        });

        return (
            <div>
                <Header handleSyncLoading={this.handleSyncLoading} />
                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-12 col-lg-6">
                            <div className="activity-info-box green-activity text-white mb-3 max-w-460">
                                <span>{activity?.activity_tag}</span>
                                <h5>{HOME_TODAY_SCREEN.SAMPLE_TO_SALE} - {SAMPLE_TO_SALE_SCREEN.HARVEST_DETAILS}</h5>
                                <span>{activity.crop_name + ", " + activity.hybrid_name + " | " + activity.village_name}</span>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <form>
                                {/* Group Meeting */}
                                <div className="harvest-details">
                                    <div className="row">
                                        <div className="col-lg-5">
                                            <div className="form-group d-flex align-items-center">
                                                <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.HARVESTING_DATE}</label>
                                                <div className="input-date w-50 max-w-360">
                                                    <input type="date" className="form-control mb-0" name="harvestingDate" value={harvestingDate} onChange={this.changeHandler} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-5">
                                            <div className="form-group acre-form-group d-flex align-items-center">
                                                <label className="w-50 mb-0">{SAMPLE_TO_SALE_SCREEN.YIELD} Kgs/5*5sqm</label>
                                                <div className="form-control w-50 max-w-360">
                                                    <input type="text" placeholder="eg. 250" name="yieldValue" value={yieldValue} onChange={this.changeHandler} />
                                                    <span>kgs</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-5">
                                            <div className="form-group d-flex align-items-center">
                                                <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.MOISTURE} %</label>
                                                <div className="w-50 max-w-360">
                                                    <input type="text" className="form-control mb-0 w-md-100" placeholder="eg. 500"
                                                        name="moisture" value={moisture} onChange={this.changeHandler} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-5">
                                            <div className="form-group d-flex align-items-center">
                                                <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.POPULATION}</label>
                                                <div className="w-50 w-md-100">
                                                    <input type="text" className="form-control mb-0 max-w-360" placeholder="eg. 500"
                                                        name="population" value={population} onChange={this.changeHandler} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-12"> <h6 className="mt-3">{SAMPLE_TO_SALE_SCREEN.VARIETY}</h6></div>


                                        {checkVariety.length > 1 ?
                                            <div className="col-lg-5">
                                                <div className="form-group d-flex align-items-center">
                                                    <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.HYBRID}</label>
                                                    <Select className="form-group w-50 w-md-100"
                                                        value={selectedCheckVariety}
                                                        onChange={this.handleVarietyHybrid}
                                                        options={checkVariety}
                                                        placeholder="Select the stage"
                                                        isClearable={false} />
                                                </div>

                                            </div> :
                                            <div className="col-lg-5">
                                                <div className="form-group d-flex align-items-center">
                                                    <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.HYBRID}</label>
                                                    <div className="w-50 w-md-100">
                                                        <input type="text" className="form-control mb-0 max-w-360" value={selectedCheckVariety?.label} disabled />
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        <div className="col-lg-5">
                                            <div className="form-group d-flex align-items-center">
                                                <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.HARVESTING_DATE}</label>
                                                <div className="input-date w-50 w-md-100">
                                                    <input type="date" className="form-control mb-0 max-w-360"
                                                        name="varietyHarvestingDate" value={varietyHarvestingDate} onChange={this.changeHandler} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-5">
                                            <div className="form-group acre-form-group d-flex align-items-center">
                                                <label className="w-50 mb-0">{SAMPLE_TO_SALE_SCREEN.YIELD} Kgs/5*5sqm</label>
                                                <div className="form-control w-50 max-w-360">
                                                    <input type="text" placeholder="eg. 250" name="varietyYield" value={varietyYield} onChange={this.changeHandler} />
                                                    <span>kgs</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-5">
                                            <div className="form-group d-flex align-items-center">
                                                <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.MOISTURE} %</label>
                                                <div className="w-50 w-md-100">
                                                    <input type="text" className="form-control mb-0 max-w-360" placeholder="eg. 500"
                                                        name="varietyMoisture" value={varietyMoisture} onChange={this.changeHandler} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-5">
                                            <div className="form-group d-flex align-items-center">
                                                <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.POPULATION}</label>
                                                <div className="w-50 w-md-100">
                                                    <input type="text" className="form-control mb-0 max-w-360" placeholder="eg. 500"
                                                        name="varietyPopulation" value={varietyPopulation} onChange={this.changeHandler} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label className="font-weight-medium mt-2">{SAMPLE_TO_SALE_SCREEN.REMARKS} <span className="font-weight-normal">(if any)</span></label>
                                                <textarea className="form-control" rows="4" name="remarks" value={remarks} onChange={this.changeHandler}></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <AddLocalImages handleAddImages={this.handleAddImages}
                                                selectedImages={images} />
                                        </div>


                                        <div className="col-lg-12">
                                            <GpsCoordinates getCoordinates={this.getCoordinates} />
                                            {/* <div className="form-group">
                                                <label className="font-weight-medium mt-2">{SAMPLE_TO_SALE_SCREEN.GPS_COORDINATES}</label>
                                                <input type="text" className="form-control max-w-460" placeholder="No data found" value={latLng} name="latLng" onChange={this.changeHandler}/>
                                                <span className="error-msg d-none"><i className="customic ic-error"></i> {SAMPLE_TO_SALE_SCREEN.GPS_ERROR}</span>
                                                <span className="mt-2 d-block gray-text gray-address">Unnamed Road, Amargarh, Haryana 126116, India</span>
                                            </div> */}
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="form-group mb-0">
                                                <label className="font-weight-medium mt-2">{SAMPLE_TO_SALE_SCREEN.NEXT_PICKING_ACTIVITY_DONE}</label>
                                                <div className="d-flex flex-wrap radiobox-container-row">
                                                    {NextActivityOptions}
                                                    {/* <div className="radiobox-container"><input type="radio" name="radio1" value={COMMON.YES} onChange={this.handleChanged} defaultChecked={nextActivity} /><span className="checkmark">{COMMON.YES}</span></div>
                                                    <div className="radiobox-container"><input type="radio" name="radio1" value={COMMON.NO} onChange={this.handleChanged} defaultChecked={!nextActivity} /><span className="checkmark">{COMMON.NO}</span></div> */}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="form-group input-date">
                                                <label></label>
                                                <input type={this.state.type} className="form-control mb-0  mt-md-3" onFocus={this.onFocus} onBlur={this.onBlur} placeholder="Pick Next Picking Date"
                                                    name="nextPickDate" value={nextPickDate} onChange={this.changeHandler} disabled={nextActivity === 'false'} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 d-flex button-grp-bottom">
                            <button className="btn btn-secondary w-50 mr-2 krishak-cancel-btn" onClick={this._backButton}>
                                {COMMON.BACK}
                            </button>
                            <button className="btn btn-primary w-50" onClick={this._handleSaveClick} disabled={this.isFormValid()}>
                                {COMMON.SAVE}
                            </button>
                        </div>
                    </div>
                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                <DesktopFooter />
            </div>
        )
    }
}

export default withRouter(HarvestDetailsPage)